import {
  TRACKING_VALIDATION_DOMAIN,
  BusinessTarget,
  BusinessTargetConfig,
} from '@shopee-user/global';

export const TRACKING_APP_ID =
  BusinessTargetConfig[__BUSINESS_TARGET__ as BusinessTarget].trackingAppId;
export const TRACKING_VALIDATION_URL = `${TRACKING_VALIDATION_DOMAIN}/api/validator/${TRACKING_APP_ID}/s`;

/**
 * https://confluence.shopee.io/pages/viewpage.action?spaceKey=SDE&title=Integration+Guide
 * The below token is for Web FE use, so this same token is also being used in PC RW
 */
export const TRACKING_VALIDATION_API_TOKEN = 'aaxc9PBBc4mExlQ';
